import React from 'react';
import './HeroSection.css';
import Button from './Button';

const HeroSection = () => {
  const scrollToUpload = () => {
    const uploadSection = document.getElementById('apk-drop-hero');
    if (uploadSection) {
      const yOffset = -90;
      const y = uploadSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <div className="app-promotion">
      <div className="app-promotion-content">
        <div className="app-promotion-text">
          <h1>Launch Your App to App Stores, Effortlessly.</h1>
          <p>Supporting Android apps on Google Play<img 
              src="/images/Google Play Store New Icon.svg" 
              alt="Google Play Store" 
              className="inline-block h-8 object-contain ml-0 mr-0 align-middle store-icon"
            />. Simply drag your AAB file, get a clear permissions analysis, instant feedback, and smoothly publish your app.
<br /><strong>No coding needed, no cost to start.</strong>
<br /><span className="text-gray-400">iOS support coming soon!</span></p>
          <div className="flex items-center gap-4">
            <Button 
              onClick={scrollToUpload}
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z" fill="currentColor" />
                </svg>
              }
            >
              Go Live on Google Play – For Free
            </Button>
          </div>
        </div>
        <div className="app-promotion-image">
          <div className="phone-container">
            <div className="phone-mockup">
              <div className="screen">
                <div className="app-screen">
                  <div className="meditation-ui">
                    <div className="header">Google Play Console</div>
                    <div className="feature-card">
                      <div className="card-image material-card"></div>
                      <div className="card-title">App Performance</div>
                      <div className="card-meta">Last updated today</div>
                    </div>
                    <div className="section-title">Recent Actions</div>
                    <div className="section-title featured">App Status</div>
                    <div className="playlist-item">
                      <div className="playlist-icon material-icon"></div>
                      <div className="playlist-text">
                        <div>App Statistics</div>
                        <div className="playlist-meta">Published and live on store</div>
                      </div>
                    </div>
                    <div className="playlist-item">
                      <div className="playlist-icon material-icon blue"></div>
                      <div className="playlist-text">
                        <div>User Ratings</div>
                        <div className="playlist-meta">Rating: 4.8 ⭐ (452 reviews)</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="phone-mockup instructor">
              <div className="instructor-screen">
                <div className="instructor-name">Google Play Store</div>
                <div className="instructor-title">Your App is Live!</div>
              </div>
            </div>
          </div>
          <div className="decorative-elements">
            <div className="purple-blob"></div>
            <div className="yellow-star"></div>
            <div className="orange-circle"></div>
            <div className="chat-bubble"></div>
          </div>
        </div>
      </div>
      <style jsx>{`
        @media (max-width: 768px) {
          .store-icon {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default HeroSection; 